// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__fOQz6","iconContainer":"Contact_iconContainer__9YoLy","icon":"Contact_icon__R+47G"};